import React, { useState, useEffect } from 'react';
import './GallerySection.css';

const GallerySection = ({ title, description, images, backgroundColor, allGalleries }) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [currentGalleryIdx, setCurrentGalleryIdx] = useState(
    allGalleries ? allGalleries.findIndex(g => g.images === images) : 0
  );

    // Affichage uniquement en mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  const galleryImages = allGalleries ? allGalleries[currentGalleryIdx].images : images;

  const openLightbox = (index) => {
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
  };

  const nextImage = () => {
    setLightboxIndex((lightboxIndex + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setLightboxIndex((lightboxIndex - 1 + galleryImages.length) % galleryImages.length);
  };

  // Ajout de l'effet pour la gestion des flèches du clavier
  useEffect(() => {
    if (lightboxIndex === null) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      } else if (e.key === 'Escape') {
        closeLightbox();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxIndex, galleryImages.length]);

  // Sélection de galerie dans la lightbox
  const handleGalleryChange = (e) => {
    setCurrentGalleryIdx(Number(e.target.value));
    setLightboxIndex(0);
  };

  return (
    <section
      className="gallery-section"
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <h2>{title}</h2>
      <p dangerouslySetInnerHTML={{ __html: description }} />
      <div className={`gallery-grid ${images.length > 4 ? 'three-columns' : images.length <= 2 ? 'three-columns' : ''}`}>
        {images.map((img, index) => (
          <div key={index} className="gallery-item" onClick={() => openLightbox(index)}>
            <div className="image-container">
                {img.tag && <div className="image-tag">{img.tag}</div>}
              <img src={img.src} alt={img.alt} loading="lazy" />
              {!isMobile && (
              <div className="image-overlay">
                <h3>{img.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: img.text }} />
              </div>
              )}
            </div>
            {isMobile && (
              <div className="image-mob-desc">
                <h3>{img.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: img.text }} />
              </div>
            )}
          </div>
        ))}
      </div>

      {lightboxIndex !== null && (
        <div className="lightbox" onClick={(e) => {
          if (e.target.classList.contains('lightbox')) {
            closeLightbox();
          }
        }}>
          <button className="close" onClick={closeLightbox} aria-label="Fermer">✖</button>
          <span className="arrow left" onClick={prevImage}>‹</span>
          <div className="lightbox-content">
            {/* Sélecteur de galerie si plusieurs galeries */}
            {allGalleries && allGalleries.length > 1 && (
              <select
                className="gallery-selector"
                value={currentGalleryIdx}
                onChange={handleGalleryChange}
              >
                {allGalleries.map((g, idx) => (
                  <option key={idx} value={idx}>{g.title || `Galerie ${idx + 1}`}</option>
                ))}
              </select>
            )}
            {galleryImages[lightboxIndex].tag && (
              <div className="lightbox-tag">{galleryImages[lightboxIndex].tag}</div>
            )}
            <img src={galleryImages[lightboxIndex].src} alt={galleryImages[lightboxIndex].alt} loading="lazy" />
            <div className="lightbox-caption">
              <h3>{galleryImages[lightboxIndex].title}</h3>
              <p>{galleryImages[lightboxIndex].text}</p>
            </div>
          </div>
          <span className="arrow right" onClick={nextImage}>›</span>
        </div>
      )}

    </section>
  );
};

export default GallerySection;
